/**
 * Where Supabase should send the user after they click the magic link.
 * Must be listed under Supabase Auth → URL Configuration → Redirect URLs.
 */
export function getMagicLinkRedirectTo(): string {
  return `${window.location.origin}/auth/callback`;
}
